import mutations from './mutations';
import { DataService } from '@/config/dataService/dataService';
import { notification } from 'ant-design-vue';

const state = () => ({
    data: [],
    total: 0,
    form: null,
    loading: false,
    error: null,
});

const actions = {
    async formReadAll({ commit }) {
        commit('formReadAllBegin');
        await DataService.get(`/forms`).then((response) => {
            commit('formReadAllSuccess', response.data.data);
        }).catch((err) => {
            commit('formReadAllErr', err);
        });
    },

    async formAdd({ commit }, payload) {
        commit('formAddBegin');
        await DataService.post(`/forms`, payload).then((response) => {
            commit('formAddSuccess');
            notification.success({
                message: response.data.message,
                placement: 'topRight',
            });
        }).catch((err) => {
            commit('formAddErr', err);
            notification.error({
                message: 'Error adding form. Please contact support.',
                placement: 'topRight',
            });
        });
    },

    async formUpdate({ commit }, payload) {
        commit('formUpdateBegin');
        await DataService.put(`/forms/${payload.id}`, payload).then((response) => {
            commit('formUpdateSuccess');
            notification.success({
                message: response.data.message,
                placement: 'topRight',
            });
        }).catch((err) => {
            commit('formUpdateErr', err);
            notification.error({
                message: 'Error updating form. Please contact support.',
                placement: 'topRight',
            });
        });
    },
};

export default {
    namespaced: false,
    state,
    actions,
    mutations,
};